export default {
    getList: {
        default: [{
            status: 1,
            time_upload: 1111111111000,
            awr_report: "awrrpt_1_5940_5941",
            remarks: 'HIS系统AWR报告分析',
        }, {
            status: 2,
            time_upload: 1231231231000,
            awr_report: "awrrpt_1_5940_5940",
            remarks: 'PACS系统AWR报告分析',
        }, {
            status: 1,
            time_upload: 1314152132000,
            awr_report: "awrrpt_1_5940_5920",
            remarks: 'LIS系统AWR报告分析',
        },
        {
            status: 0,
            time_upload: 5125322132000,
            awr_report: "awrrpt_1_5940_5920",
            remarks: 'LIS系统AWR报告分析',
        },
        {
            status: 3,
            time_upload: 4352532132000,
            awr_report: "awrrpt_1_5940_5920",
            remarks: 'LIS系统AWR报告分析',
        },{
            status: 2,
            time_upload: 6442622132000,
            awr_report: "awrrpt_1_5940_5920",
            remarks: 'LIS系统AWR报告分析',
        }]
    }
}